import { default as _91id_93KAnmTgLk6NMeta } from "/app/web/pages/admin/entities/[id].vue?macro=true";
import { default as indexcwWXUJEQqcMeta } from "/app/web/pages/admin/entities/index.vue?macro=true";
import { default as indexidAq3K47XZMeta } from "/app/web/pages/admin/integrations/index.vue?macro=true";
import { default as _91id_93rTbT00gxyzMeta } from "/app/web/pages/cards/[id].vue?macro=true";
import { default as create5JSSxxvi7dMeta } from "/app/web/pages/collaborators/create.vue?macro=true";
import { default as indexUb7prxE8VUMeta } from "/app/web/pages/collaborators/index.vue?macro=true";
import { default as indexV7AdkCA0pdMeta } from "/app/web/pages/entities/activities/index.vue?macro=true";
import { default as indexMOsGXyi0D8Meta } from "/app/web/pages/entities/collaborators/index.vue?macro=true";
import { default as indexoYBJQRT9p9Meta } from "/app/web/pages/entities/redirects/index.vue?macro=true";
import { default as indextVqqNvhLn2Meta } from "/app/web/pages/entities/tenants/index.vue?macro=true";
import { default as indexYS78NDwcUGMeta } from "/app/web/pages/entities/users/index.vue?macro=true";
import { default as indexTGy7mhq7bEMeta } from "/app/web/pages/index.vue?macro=true";
import { default as loginaM4XdV5ucjMeta } from "/app/web/pages/login.vue?macro=true";
import { default as _91id_93mJfYraBkLZMeta } from "/app/web/pages/redirects/[id].vue?macro=true";
import { default as indexiOl1fe8cCXMeta } from "/app/web/pages/redirects/index.vue?macro=true";
import { default as indexS3UbhnFbpsMeta } from "/app/web/pages/tenants/index.vue?macro=true";
import { default as createVn5RVez7OiMeta } from "/app/web/pages/wizard/tenants/create.vue?macro=true";
import { default as findWwxgQ4KCFMMeta } from "/app/web/pages/wizard/tenants/find.vue?macro=true";
export default [
  {
    name: "admin-entities-id",
    path: "/admin/entities/:id()",
    component: () => import("/app/web/pages/admin/entities/[id].vue").then(m => m.default || m)
  },
  {
    name: "admin-entities",
    path: "/admin/entities",
    meta: indexcwWXUJEQqcMeta || {},
    component: () => import("/app/web/pages/admin/entities/index.vue").then(m => m.default || m)
  },
  {
    name: "admin-integrations",
    path: "/admin/integrations",
    meta: indexidAq3K47XZMeta || {},
    component: () => import("/app/web/pages/admin/integrations/index.vue").then(m => m.default || m)
  },
  {
    name: "cards-id",
    path: "/cards/:id()",
    meta: _91id_93rTbT00gxyzMeta || {},
    component: () => import("/app/web/pages/cards/[id].vue").then(m => m.default || m)
  },
  {
    name: "collaborators-create",
    path: "/collaborators/create",
    component: () => import("/app/web/pages/collaborators/create.vue").then(m => m.default || m)
  },
  {
    name: "collaborators",
    path: "/collaborators",
    meta: indexUb7prxE8VUMeta || {},
    component: () => import("/app/web/pages/collaborators/index.vue").then(m => m.default || m)
  },
  {
    name: "entities-activities",
    path: "/entities/activities",
    component: () => import("/app/web/pages/entities/activities/index.vue").then(m => m.default || m)
  },
  {
    name: "entities-collaborators",
    path: "/entities/collaborators",
    component: () => import("/app/web/pages/entities/collaborators/index.vue").then(m => m.default || m)
  },
  {
    name: "entities-redirects",
    path: "/entities/redirects",
    component: () => import("/app/web/pages/entities/redirects/index.vue").then(m => m.default || m)
  },
  {
    name: "entities-tenants",
    path: "/entities/tenants",
    component: () => import("/app/web/pages/entities/tenants/index.vue").then(m => m.default || m)
  },
  {
    name: "entities-users",
    path: "/entities/users",
    meta: indexYS78NDwcUGMeta || {},
    component: () => import("/app/web/pages/entities/users/index.vue").then(m => m.default || m)
  },
  {
    name: "index",
    path: "/",
    component: () => import("/app/web/pages/index.vue").then(m => m.default || m)
  },
  {
    name: "login",
    path: "/login",
    meta: loginaM4XdV5ucjMeta || {},
    component: () => import("/app/web/pages/login.vue").then(m => m.default || m)
  },
  {
    name: "redirects-id",
    path: "/redirects/:id()",
    meta: _91id_93mJfYraBkLZMeta || {},
    component: () => import("/app/web/pages/redirects/[id].vue").then(m => m.default || m)
  },
  {
    name: "redirects",
    path: "/redirects",
    meta: indexiOl1fe8cCXMeta || {},
    component: () => import("/app/web/pages/redirects/index.vue").then(m => m.default || m)
  },
  {
    name: "tenants",
    path: "/tenants",
    meta: indexS3UbhnFbpsMeta || {},
    component: () => import("/app/web/pages/tenants/index.vue").then(m => m.default || m)
  },
  {
    name: "wizard-tenants-create",
    path: "/wizard/tenants/create",
    meta: createVn5RVez7OiMeta || {},
    component: () => import("/app/web/pages/wizard/tenants/create.vue").then(m => m.default || m)
  },
  {
    name: "wizard-tenants-find",
    path: "/wizard/tenants/find",
    meta: findWwxgQ4KCFMMeta || {},
    component: () => import("/app/web/pages/wizard/tenants/find.vue").then(m => m.default || m)
  }
]